const SEARCH_SUBMISSION_ID_PATTERN =
	/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function createSearchSubmissionId(): string {
	return createBrowserUuid();
}

export function parseSearchSubmissionId(value: string | string[] | undefined): string | undefined {
	const candidate = Array.isArray(value) ? value[0] : value;
	if (!candidate || !SEARCH_SUBMISSION_ID_PATTERN.test(candidate)) return undefined;
	return candidate.toLowerCase();
}
import { createBrowserUuid } from "@/lib/browser-uuid";
